import {ReactNode} from "react";
import PortalUnavailable from "./features/PortalUnavailable";
import SherbrookeWelcomePage from "./features/SherbrookeWelcomePage";

type WelcomeScreen = {
	path: string;
	component: ReactNode;
}

export const enum PublicRoutes {
	signIn = "/auth/signin",
	signUp = "/auth/signup",
	forgotPassword = "/auth/forgot-password",
	welcome = "/welcome",
	home = "/"
}

export const enum PrivateRoutes {
	permitsHome = "/home",
	permitsNew = "/home/{0}",
	permitsList = "/permits",
	permitView = "/permits/{0}",
	permitGroupView = "/permits/groups/{0}",
	permitDocumentationUpdate = "/permits/{0}/documentation-update",
	permitsRenew = "/permits/renew/{0}",
	permitsUnpark = "/permits/unpark/{0}",

	reservationView = "/reservations/{0}",
	reservationApprovement = "/reservations/{0}/approve",
	// reservationsSignal = "/reservations/{0}/signal",

	holderView = "/holder",

	driverView = "/drivers/{0}",
	// driverCreate = "/drivers/create",
	residencyView = "/residencies/{0}",
	residenciesCreate = "/residencies/create",

	vehicles = "/vehicles",
	vehicleView = "/vehicles/{0}",
	vehiclesCreate = "/vehicles/create",
	vehicleEdit = "/vehicles/{0}/edit",

	documents = "/documents",
	documentUpdate = "/documents/{0}/update",
	documentsExpired = "/documents/expired",

	payments = "/payments",

	invoices = "/invoices",
	settings = "/settings",
	completeProfile = "/complete-profile",
}

export function formatRoute(route: string, ...params: any[]): string {
	for (let i = 0; i < params.length; ++i) {
		route = route.replace(`{${i}}`, encodeURIComponent(params[i]));
	}

	return route;
}

export const WelcomeScreens: Record<string, WelcomeScreen> = {
	"portal-unavailable": {
		path: "/unavailable",
		component: <PortalUnavailable/>
	},
	"sherbrooke-welcome": {
		path: "/swelcome",
		component: <SherbrookeWelcomePage/>
	}
}

export function getWelcomeRoutes(): WelcomeScreen[] {
	const routes: WelcomeScreen[] = [];
	for (const value of Object.values(WelcomeScreens)) {
		routes.push(value);
	}

	return routes;
}
